import React, { useState } from 'react';
import './index.css';
import { NavLink, useLocation } from 'react-router-dom';

/**
 * The SideBarNav component has four menu items: "Questions", "Tags", "Messaging", and "Users".
 * It highlights the currently selected item based on the active page and
 * triggers corresponding functions when the menu items are clicked.
 */
const SideBarNav = () => {
  const [showOptions, setShowOptions] = useState<boolean>(false);
  const location = useLocation();

  const toggleOptions = () => {
    setShowOptions(!showOptions);
  };

  const isActiveOption = (path: string) =>
    location.pathname === path ? 'message-option-selected ' : '';

  return (
    <div id='sideBarNav' className='sideBarNav'>
      <NavLink
        to='/home'
        id='menu_questions'
        className={({ isActive }) => `menu_button ${isActive ? 'menu_selected' : ''}`}
        aria-label='Questions'>
        <i className='material-icons text-xl'>quiz</i>
        <span>Questions</span>
      </NavLink>

      <NavLink
        to='/tags'
        id='menu_tag'
        className={({ isActive }) => `menu_button ${isActive ? 'menu_selected' : ''}`}
        aria-label='Tags'>
        <i className='material-icons text-xl'>local_offer</i>
        <span>Tags</span>
      </NavLink>

      <NavLink
        to='/messaging'
        id='menu_messaging'
        className={({ isActive }) => `menu_button ${isActive ? 'menu_selected' : ''}`}
        aria-label='Messaging'
        onClick={toggleOptions}>
        <i className='material-icons text-xl'>chat</i>
        <span>Messaging</span>
      </NavLink>

      {showOptions && (
        <div className='additional-options'>
          <NavLink
            to='/messaging'
            className={`menu_button message-options ${isActiveOption('/messaging')}`}
            aria-label='Global Messaging'>
            Global Messages
          </NavLink>
          <NavLink
            to='/messaging/direct-message'
            className={`menu_button message-options ${isActiveOption('/messaging/direct-message')}`}
            aria-label='Direct Messaging'>
            Direct Messages
          </NavLink>
        </div>
      )}

      <NavLink
        to='/users'
        id='menu_users'
        className={({ isActive }) => `menu_button ${isActive ? 'menu_selected' : ''}`}
        aria-label='Users'>
        <i className='material-icons text-xl'>people</i>
        <span>Users</span>
      </NavLink>

      <NavLink
        to='/games'
        id='menu_games'
        className={({ isActive }) => `menu_button ${isActive ? 'menu_selected' : ''}`}
        aria-label='Games'>
        <i className='material-icons text-xl'>videogame_asset</i>
        <span>Games</span>
      </NavLink>

      <NavLink
        to='/watch'
        id='menu_watchparty'
        className={({ isActive }) => `menu_button ${isActive ? 'menu_selected' : ''}`}
        aria-label='Watch-Party'>
        <i className='material-icons text-xl'>tv</i>
        <span>Watch Party</span>
      </NavLink>

      <NavLink
        to='/calendar'
        id='menu_calendar'
        className={({ isActive }) => `menu_button ${isActive ? 'menu_selected' : ''}`}>
        <i className='material-icons text-xl'>event</i>
        Calendar
      </NavLink>
    </div>
  );
};

export default SideBarNav;
